export default {"src":"/_next/static/media/logo.3a34f0c7.svg","height":482,"width":605,"blurWidth":0,"blurHeight":0};